import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {DeptPO} from "@/model/system";
import {PaybackPO} from "@/model/finance";
import {ContractPO} from "@/model/customer";

export enum DeptEnum {
    GetDeptTree = "/dept/getDeptTree",
    GetDept = "/dept/getDept",
    CreateDept = "/dept/createDept",
    UpdateDept = "/dept/updateDept",
}

export interface DeptTreeBO {
}

export interface DeptTreeVO extends DeptPO {
}

export interface DeptVO extends DeptPO {
    paybacks: PaybackPO[];
    contract: ContractPO
    contact: string
    mobile: string;
}

export interface ReceiveDeptBO {
    instanceId: number;
    businessId: number;
    executeId: string;
}

export const useQueryDeptTree = () => useQuery({
    queryKey: ["queryDeptTree"],
    queryFn: (data: DeptTreeBO) => http.get<BaseVO<DeptTreeVO[]>>({
        url: DeptEnum.GetDeptTree,
        data,
    }),
})

export const useCreateDept = () => useMutation({
    mutationFn: (data: any) => http.put<BaseVO<null>>({
        url: DeptEnum.CreateDept,
        data
    }),
})

export const useUpdateDept = () => useMutation({
    mutationFn: (data: any) => http.post<BaseVO<null>>({
        url: DeptEnum.UpdateDept,
        data
    }),
})

export const useQueryDept = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<DeptVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<DeptVO>>({
        url: DeptEnum.GetDept,
        params: params
    }),
    enabled
})


